/**
 * 実績詳細ページ
 */
import { useParams } from 'react-router-dom';

function WorkDetail() {
  const { id } = useParams();  // URLから作品IDを取得

  // TODO: idを使ってAPIから作品データを取得

  return (
    <div>
      <h1>作品詳細 (ID: {id})</h1>
      {/* TODO: 作品の詳細を表示 */}
    </div>
  );
}

export default WorkDetail;
